module.exports = __webpack_public_path__ + "static/img/3-1-3.fbde306a.jpg";